import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_tasks_by_licenseplateIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplateId: number }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ActualTargetShippingContainerId?: number, CompletedDateTime?: string, Employee?: string, ExpectedPackagedPackId?: number, GrossVolume?: number, GrossWeight?: number, LotId?: number, MaterialId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StartDateTime?: string, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_tasks_by_licenseplateId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licenseplateId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ActualTargetShippingContainerId?: number, CompletedDateTime?: string, Employee?: string, ExpectedPackagedPackId?: number, GrossVolume?: number, GrossWeight?: number, LotId?: number, MaterialId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StartDateTime?: string, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number }[] } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_tasks_by_licenseplateId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licenseplateId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ActualTargetShippingContainerId?: number, CompletedDateTime?: string, Employee?: string, ExpectedPackagedPackId?: number, GrossVolume?: number, GrossWeight?: number, LotId?: number, MaterialId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StartDateTime?: string, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_tasks_by_licenseplateId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licenseplateId: number    }) {
        if(isNil(inParams.licenseplateId)) {
          return true; 
        }
      return false;
    }
}
